import { useAsyncOperationState } from '../../../dorian-shared/hooks/useAsyncOperationState';
import { api } from '../../api';
import { createFormDataFromOfferFormValues, OfferFormValues } from './components/OfferForm/offerFormLogic';

export function useUpdateOffer(offerId: number) {
  const [, {
    isLoading, setToLoading, setToError, setToSuccess,
  }] = useAsyncOperationState();

  const updateOffer = (values: OfferFormValues) => {
    setToLoading();
    return api.put(`/v1/offers/${offerId}`, createFormDataFromOfferFormValues(values), {
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then((response) => {
        setToSuccess();
        return response.data.offer;
      })
      .catch((error) => {
        setToError();
        throw new Error(error.response?.data?.error ?? 'The offer could not be updated. Check your connection and try again.');
      });
  };
  return { isLoading, updateOffer };
}
